import { Controller } from "@hotwired/stimulus"

// Screenshot gallery: thumbnails swap the large frame.
export default class extends Controller {
  static targets = ["frame", "caption", "thumb"]

  select(event) {
    const thumb = event.currentTarget
    const { src, caption } = thumb.dataset

    this.frameTarget.src = src
    this.frameTarget.alt = caption || this.frameTarget.alt

    if (this.hasCaptionTarget) {
      this.captionTarget.textContent = caption || ""
      this.captionTarget.hidden = !caption
    }

    this.thumbTargets.forEach((element) => {
      const active = element === thumb
      element.classList.toggle("border-ink", active)
      element.classList.toggle("border-line", !active)
      element.setAttribute("aria-current", active ? "true" : "false")
    })
  }
}
